
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      settings: 'settings/settings'
    }),
    description () {
      if (this.settings) {
        return this.settings['site_description.' + this.$i18n.locale]
      }
      return ''
    },
    phones () {
      if (this.settings && this.settings.phone_number) {
        return this.settings.phone_number.split(',')
      }
      return []
    }
  }
}
